import { render, staticRenderFns } from "./DS_Special.vue?vue&type=template&id=e8bbc996&"
import script from "./DS_Special.vue?vue&type=script&lang=js&"
export * from "./DS_Special.vue?vue&type=script&lang=js&"
import style0 from "./DS_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports